import React from 'react';
import { Box } from '@mui/material';

import { ReactComponent as SuccessIcon } from 'assets/images/ic-modal-success.svg';
import { Button, Container, ContainerItem, Dialog } from 'ui';
import { Header, Text } from 'ui/atoms';

interface LicenseFoundSuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export const LicenseFoundSuccessModal: React.FC<LicenseFoundSuccessModalProps> = (props) => {
  const { isOpen, onClose, onSubmit } = props;

  return (
    <Dialog
      handleClose={onClose}
      isOpen={isOpen}
      noCancelAction
      action={<Button fullWidth color="primary" label="Great!" onClick={onSubmit} />}
    >
      <Container column data-cy="verify-license-container" padding={0} width="100%">
        <ContainerItem justify="center" height="300px" width="100%">
          <Box sx={{ color: (theme) => theme.palette.primary.main }}>
            <SuccessIcon />
          </Box>
          <br />
          <Header type="h2" content="Success!" />
          <br />
          <Text content="Your license has been officially verified." />
        </ContainerItem>
      </Container>
    </Dialog>
  );
};
